export default {
  title: "403 Interdit",
  description:
    "Désolé, vous n'avez pas la permission d'accéder à cette page. Veuillez contacter votre administrateur si vous pensez qu'il s'agit d'une erreur.",
  goHome: "Aller à la page d'accueil",
  goBack: "Retourner en arrière",
};
